const addressStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@400;700;900&family=Cinzel:wght@400;600;700&family=Noto+Serif:ital,wght@0,400;0,600;1,400&display=swap');

  .address-section {
    background: linear-gradient(180deg, #1a0000 0%, #2d0000 100%);
    padding: 5rem 2rem;
    position: relative; overflow: hidden;
  }
  .address-section::before {
    content: ''; position: absolute;
    top: 0; left: 0; right: 0; height: 3px;
    background: linear-gradient(90deg, transparent, #C9920A, #F0C040, #C9920A, transparent);
  }
  .address-section::after {
    content: ''; position: absolute;
    top: -200px; right: -200px;
    width: 500px; height: 500px; border-radius: 50%;
    background: radial-gradient(circle, rgba(139,0,0,0.15), transparent 60%);
    pointer-events: none;
  }
  .address-inner {
    max-width: 1100px; margin: 0 auto;
    position: relative; z-index: 1;
  }
  .address-header { text-align: center; margin-bottom: 3.5rem; }
  .section-label {
    font-family: 'Cinzel', serif;
    font-size: 0.7rem; letter-spacing: 0.3em;
    text-transform: uppercase; color: #C9920A; margin-bottom: 0.75rem;
  }
  .address-header h2 {
    font-family: 'Cinzel Decorative', serif;
    font-size: 1.9rem; font-weight: 700;
    color: #F0C040;
    text-shadow: 0 0 30px rgba(240,192,64,0.3);
  }
  .address-grid {
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem;
  }
  .address-card {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(201,146,10,0.2);
    border-top: 2px solid #C9920A;
    border-radius: 4px; padding: 2rem 1.75rem;
    transition: all 0.3s; position: relative; overflow: hidden;
  }
  .address-card::before {
    content: ''; position: absolute; top: 0; left: 0;
    width: 100%; height: 100%;
    background: linear-gradient(135deg, rgba(201,146,10,0.05), transparent);
    opacity: 0; transition: opacity 0.3s;
  }
  .address-card:hover {
    border-color: rgba(201,146,10,0.5);
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(0,0,0,0.3);
  }
  .address-card:hover::before { opacity: 1; }
  .card-icon {
    width: 52px; height: 52px; border-radius: 50%;
    background: linear-gradient(135deg, rgba(139,0,0,0.5), rgba(70,0,0,0.8));
    border: 1px solid rgba(201,146,10,0.4);
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 1.25rem; font-size: 1.5rem;
    box-shadow: 0 4px 15px rgba(0,0,0,0.3);
  }
  .card-title {
    font-family: 'Cinzel', serif; font-size: 0.78rem;
    font-weight: 700; letter-spacing: 0.2em;
    text-transform: uppercase; color: #C9920A; margin-bottom: 1rem;
  }
  .card-body {
    font-family: 'Noto Serif', serif;
    font-size: 0.95rem; line-height: 1.8; color: #d4b896;
  }
  .card-body a { color: #d4b896; text-decoration: none; transition: color 0.2s; }
  .card-body a:hover { color: #F0C040; }
  .phone-number {
    display: flex; align-items: center; gap: 8px;
    margin-bottom: 0.5rem;
  }
  .phone-number span { font-size: 0.8rem; }
  .time-row {
    display: flex; align-items: flex-start;
    gap: 10px; margin-bottom: 0.75rem;
    color: #d4b896; font-family: 'Noto Serif', serif; font-size: 0.93rem;
  }
  .time-label {
    font-family: 'Cinzel', serif; font-size: 0.62rem;
    font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase;
    color: #C9920A; background: rgba(201,146,10,0.12);
    border: 1px solid rgba(201,146,10,0.25);
    padding: 2px 8px; border-radius: 2px;
    white-space: nowrap; margin-top: 2px; flex-shrink: 0;
  }
  .map-cta { text-align: center; margin-top: 3rem; }
  .map-btn {
    display: inline-flex; align-items: center; gap: 10px;
    font-family: 'Cinzel', serif; font-size: 0.8rem;
    font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase;
    color: #4A0000;
    background: linear-gradient(135deg, #F0C040, #C9920A);
    padding: 14px 36px; border: none; border-radius: 2px;
    cursor: pointer; box-shadow: 0 4px 20px rgba(201,146,10,0.3);
    transition: all 0.3s; text-decoration: none;
  }
  .map-btn:hover {
    box-shadow: 0 6px 30px rgba(201,146,10,0.5);
    transform: translateY(-2px);
  }
  @media (max-width: 768px) {
    .address-grid { grid-template-columns: 1fr; }
    .address-header h2 { font-size: 1.5rem; }
  }
`;

const Address = () => (
  <>
    <style>{addressStyles}</style>
    <section className="address-section">
      <div className="address-inner">

        <div className="address-header">
          <p className="section-label">Find Us</p>
          <h2>Visit the Sacred Madam</h2>
        </div>

        <div className="address-grid">

          {/* Card 1 – Location */}
          <div className="address-card">
            <div className="card-icon">📍</div>
            <p className="card-title">Address</p>
            <p className="card-body">
              No. 35, Beri Kaliamman Kovil Street,<br />
              Beri Pettai, Near Gandhi Road<br />
              &amp; Main Bazaar,<br />
              Kaliman Kovil,<br />
              <strong style={{ color: "#f0c040" }}>Vellore – 632004</strong>
            </p>
          </div>

          {/* Card 2 – Contact */}
          <div className="address-card">
            <div className="card-icon">📞</div>
            <p className="card-title">Contact Us</p>
            <div className="card-body">
              <div className="phone-number">
                <span>☎</span>
                <a href="tel:+919443313744">+91 94433 13744</a>
              </div>
              <div className="phone-number">
                <span>☎</span>
                <a href="tel:+919894481590">+91 98944 81590</a>
              </div>
            </div>
          </div>

          {/* Card 3 – Timings */}
          <div className="address-card">
            <div className="card-icon">⏰</div>
            <p className="card-title">Darshan Timings</p>
            <div>
              <div className="time-row">
                <span className="time-label">Morning</span>
                <span>7:00 AM – 12:00 Noon</span>
              </div>
              <div className="time-row">
                <span className="time-label">Evening</span>
                <span>5:30 PM – 7:30 PM</span>
              </div>
            </div>
          </div>

        </div>

       

      </div>
    </section>
  </>
);

export default Address;